import request from "@/utils/request";
import storage from "store";
import {TENANT} from "@/store/mutation-types";

const api = {
  getImChatList: "/im/chat",
  pageChatMessage: "/im/chat/message",
  createEmptyChat: "/im/chat/create",
  getUnreadTotal: "/im/chat/unread/total",
  readChatMessage: "/im/chat/read"
};

function getApiUrl (path) {
  const tenant = storage.get(TENANT)
  return process.env.VUE_APP_API_ADMIN_URL.replace("#tenant#", tenant) + path
}

export function getImChatList(parameter) {
  return request({
    url: getApiUrl(api.getImChatList),
    method: "get",
    params: parameter,
  });
}


export function pageChatMessage(parameter) {
  return request({
    url: getApiUrl(api.pageChatMessage),
    method: "get",
    params: parameter,
  });
}

export function createEmptyChat(parameter) {
  return request({
    url: getApiUrl(api.createEmptyChat),
    method: "post",
    data: parameter,
  });
}

export function getUnreadTotal(parameter) {
  return request({
    url: getApiUrl(api.getUnreadTotal),
    method: "get",
    params: parameter,
  });
}

export function readChatMessage(parameter) {
  return request({
    url: getApiUrl(api.readChatMessage),
    method: "post",
    params: parameter,
  });
}
